import Breadcrumbs from "../../commonComponents/breadcrumbs";
import { routes } from "../../../routers/routes";
import GridView from "../../commonComponents/gridView";

const JobRightListContainer = () => {
  return (
    <>
      <Breadcrumbs title="Job Listing" url={routes.Home.JobDemo1} mainClass="job-breadcrumbs-section" />
      <GridView type="job" sectionClass="job-list-section" filterTagsClass="job-list-header" gridType="list-view" side="right" jobBoxStyle="listing" gridSize={1} />
    </>
  );
};

export default JobRightListContainer;
